import type { RouterConfig } from '@nuxt/schema'
import { createWebHistory, type RouterScrollBehavior } from 'vue-router'

const setupScrollBehavior = (): RouterScrollBehavior => {
  return (to, _, savedPosition) => {
    if (savedPosition) {
      return { ...savedPosition, behavior: 'smooth' }
    }

    if (to.hash) {
      return { el: to.hash }
    }

    return { top: 0, behavior: 'auto' }
  }
}

export default {
  scrollBehavior: setupScrollBehavior(),
  history() {
    return createWebHistory(process.env.BASE_URL)
  },
} satisfies RouterConfig
